"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Remove any value found in `keys` from the provided object
 *
 * @param {Object} obj
 * @param {String[]} keys
 */

var _default = function _default(obj, keys) {
  return Object.keys(obj).reduce(function (result, key) {
    if (!keys.includes(key)) {
      result[key] = obj[key];
    }

    return result;
  }, {});
};

exports["default"] = _default;